import state from './modulePdfTemplateManagementState.js'
import mutations from './modulePdfTemplateManagementMutations.js'
import actions from './modulePdfTemplateManagementActions.js'
import getters from './modulePdfTemplateManagementGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

